module.exports = __webpack_public_path__ + "img/BLK.7a98f4c8.svg";